import { render } from "./SlideTabs.vue?vue&type=template&id=fc72a1a4&scoped=true"
import script from "./SlideTabs.vue?vue&type=script&lang=js"
export * from "./SlideTabs.vue?vue&type=script&lang=js"

import "./SlideTabs.vue?vue&type=style&index=0&id=fc72a1a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc72a1a4"]])

export default __exports__